export default "__VITE_ASSET__BiTDw8$7__"